import React, { createContext, useContext, useState, useEffect } from 'react';

const FontSizeContext = createContext();

export const useFontSize = () => {
  const context = useContext(FontSizeContext);
  if (!context) {
    throw new Error('useFontSize must be used within a FontSizeProvider');
  }
  return context;
};

export const FontSizeProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState('medium');

  // Load font size from localStorage on mount
  useEffect(() => {
    const savedFontSize = localStorage.getItem('userFontSize');
    if (savedFontSize && ['small', 'medium', 'large', 'xlarge', 'huge'].includes(savedFontSize)) {
      setFontSize(savedFontSize);
    }
  }, []);

  // Save font size to localStorage when it changes
  const updateFontSize = (newSize) => {
    setFontSize(newSize);
    localStorage.setItem('userFontSize', newSize);
  };

  // Get font size values for different elements
  const getFontSizes = () => {
    const baseSizes = {
      small: {
        base: '12px',
        itemName: '13px',
        itemQuantity: '11px',
        itemNotes: '11px',
        categoryTitle: '14px',
        categoryCount: '10px'
      },
      medium: {
        base: '14px',
        itemName: '15px',
        itemQuantity: '13px',
        itemNotes: '12px',
        categoryTitle: '16px',
        categoryCount: '12px'
      },
      large: {
        base: '16px',
        itemName: '17px',
        itemQuantity: '15px',
        itemNotes: '14px',
        categoryTitle: '18px',
        categoryCount: '14px'
      },
      xlarge: {
        base: '18px',
        itemName: '20px',
        itemQuantity: '17px',
        itemNotes: '16px',
        categoryTitle: '21px',
        categoryCount: '16px'
      },
      huge: {
        base: '22px',
        itemName: '24px',
        itemQuantity: '20px',
        itemNotes: '18px',
        categoryTitle: '25px',
        categoryCount: '18px'
      }
    };
    
    return baseSizes[fontSize] || baseSizes.medium;
  };

  const getFontSizeLabel = () => {
    const labels = {
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      xlarge: 'X-Large',
      huge: 'Huge'
    };
    return labels[fontSize] || 'Medium';
  };

  return (
    <FontSizeContext.Provider 
      value={{ 
        fontSize, 
        updateFontSize, 
        getFontSizes, 
        getFontSizeLabel 
      }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};
